import axios from "axios";
import CognitoController from "../../../common/scripts/cognito_controller";
import SignalMappingComponent from "../signal_mapping";
import { RequestParamsMaker } from "../scripts/make_request_params";

/**
 * マッピングテーブルが持つsignallamp_idと一致するコンポーネントテーブルのレコードを取得し、
 * 更にそのレコードが持つselect_device_idを自分のselectDeviceIdに格納する
 * @param self
 */
export async function getSignallampComponentSetting(self: SignalMappingComponent) {
  try {
    const userID: string = self.userID;
    await CognitoController.refreshToken();
    const requestParams: object = RequestParamsMaker.makeGetSignallampComponentSettingDataParams(
      self,
      userID,
    );
    const apiResponse: any = await axios(requestParams);
    self.mstSignallampComponent = apiResponse.data.res.mst_signallamp_component_settings;
    if (self.mstSignallampComponent) {
      self.selectDeviceId = self.mstSignallampComponent.select_device_id;
      self.useAlertSound = self.mstSignallampComponent.use_alert_sound;
      return apiResponse;
    }
    return false;
  } catch (e) {
    alert(self.$t("message.failedToRetrieveSettings"));
  }
}
